import React, { forwardRef } from "react";
import { BSDiv } from "../../types";

export const ToastBody = forwardRef<HTMLDivElement, BSDiv>(
  ({ className = "", children, ...props }, ref) => {
    return (
      <div {...props} className={`toast-body ${className}`} ref={ref}>
        {children}
      </div>
    );
  }
);